import { render, staticRenderFns } from "./NewAlertSet.vue?vue&type=template&id=8347988a&scoped=true"
import script from "./NewAlertSet.vue?vue&type=script&lang=js"
export * from "./NewAlertSet.vue?vue&type=script&lang=js"
import style0 from "./NewAlertSet.vue?vue&type=style&index=0&id=8347988a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8347988a",
  null
  
)

export default component.exports